import * as React from "react";

const SignInIcon: React.FC = () => {
    return (
        <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width="41.000000pt"
            height="41.000000pt"
            viewBox="0 0 41.000000 41.000000"
            preserveAspectRatio="xMidYMid meet"
        >
            <g transform="translate(0.000000,41.000000) scale(0.100000,-0.100000)" fill="#00539b" stroke="none">
                <path
                    d="M135 395 c-53 -19 -111 -82 -125 -136 -46 -169 134 -315 290 -234 41
21 88 80 101 127 20 77 -3 152 -65 206 -57 50 -127 63 -201 37z m153 -26 c88
-43 126 -153 82 -243 -26 -55 -40 -59 -40 -10 0 48 -14 70 -52 83 -24 9 -29
14 -20 23 17 17 15 68 -5 90 -20 22 -70 23 -95 1 -20 -18 -24 -73 -6 -91 9 -9
4 -14 -20 -23 -38 -13 -52 -35 -52 -83 0 -49 -14 -45 -40 10 -76 157 89 319
248 243z m-48 -69 c23 -23 24 -33 10 -61 -7 -13 -21 -19 -45 -19 -33 0 -55 20
-55 49 0 16 38 51 55 51 8 0 24 -9 35 -20z m55 -135 c27 -27 35 -91 13 -113
-20 -20 -26 -14 -34 31 l-8 42 -6 -50 -5 -50 -50 0 -50 0 -3 48 c-4 57 -22 63
-22 7 0 -22 -4 -40 -8 -40 -39 0 -44 89 -7 125 21 22 33 25 90 25 57 0 69 -3
90 -25z"
                />
            </g>
        </svg>
    );
};

export default React.memo(SignInIcon);
